import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  standalone: false,
})
export class LogoComponent implements OnInit {
  @Input() customClass = '';
  @Input() variant: 'full' | 'mini' = 'full';
  isDarkMode = false;

  constructor() { }

  get logoSrc(): string {
    if (this.variant === 'mini') {
      return this.isDarkMode
        ? 'assets/images/logo/FinanceLogix_ICON_DARK@2x.png'
        : 'assets/images/logo/logo.png';
    } else {
      return this.isDarkMode
        ? 'assets/images/logo/FinanceLogix_LOGO_DARK@2x.png'
        : 'assets/images/logo/FinanceLogic-RGB.svg';
    }
  }

  ngOnInit() { }

}
